// extracted by mini-css-extract-plugin
module.exports = {"label":"TextInput_label__4kBRv"};